"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCssUnit = exports.convertObjToFun = exports.pipeFnAndObject = void 0;
var pipeFnAndObject = function (val) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return args.reduce(function (acc, arg) {
        if (typeof arg === "function")
            return arg(acc) || acc;
        return arg[acc] || acc;
    }, val);
};
exports.pipeFnAndObject = pipeFnAndObject;
var convertObjToFun = function (object) {
    return function (val) {
        return object[val];
    };
};
exports.convertObjToFun = convertObjToFun;
var toCssUnit = function (val, unit) {
    if (unit === void 0) { unit = "px"; }
    if (typeof val === "number")
        return "" + val + unit;
    return val;
};
exports.toCssUnit = toCssUnit;
